import { render, staticRenderFns } from "./manage-notification.vue?vue&type=template&id=0a33a44d&scoped=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-notification.vue?vue&type=style&index=0&id=0a33a44d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33a44d",
  null
  
)

export default component.exports